import AsyncLoader from '@molecules/AsyncLoader'
import { mapGetters } from 'vuex'

export default {
  components: {
    AsyncLoader
  },
  computed: {
    ...mapGetters([
      'isInternalUser',
      'paymentHistory',
      'paymentHistoryLoading',
      'invoicePaymentHistory',
      'invoicePaymentHistoryLoading',
      'invoicePaymentHistoryUserMessage',
      'invoices',
      'filteredInvoices',
      'invoicesLoading',
      'invoicesUserMessage',
      'currentPaymentMethod',
      'paymentMethodsLoading',
      'userPaymentMethods',
      'userPaymentMethodsLoading',
      'userPaymentMethodsByLob',
      'hasUserPaymentMethods',
      'hasUserPaymentMethodsByLob',
      'cybersourceDetailsLoading',
      'cybersourceDetails',
      'autoPayDetails',
      'autoPayDetailsLoading',
      'makingPayment',
      'payment',
      'paymentInvoices',
      'currentBalanceDue',
      'lastPaymentMade',
      'subGroupDetailsLoading',
      'subGroupDetails',
      'paymentsAvailable',
      'paymentsAvailableForSubGroup',
      'lobId',
      'cashOnAccountsLoading',
      'onetimePaymentDetails',
      'autoPayEnabled',
      'paymentHistoryConfigurationLoading',
      'paymentHistoryEnabled'
    ])
  }
}
